/* Core Energy cart drawer.
   Free-shipping progress (theme setting) + optional merchant-configured bonus tier,
   contextual upsells, AJAX add/change. */
(function () {
  if (window.__ceCart) return;
  window.__ceCart = true;

  var el, cfg, state = { cart: null, recs: {}, lastTotal: null, lastCount: null, lastKeys: {}, tweens: {} };
  var SPORTS = ['softball', 'baseball', 'golf'];
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel) { return el.querySelector(sel); }
  function $$(sel) { return el.querySelectorAll(sel); }
  function esc(str) { return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function root() { return el.getAttribute('data-root') || '/'; }
  function url(path) { return root().replace(/\/$/, '') + path; }
  function num(attr) { return parseInt(el.getAttribute(attr), 10) || 0; }

  function money(cents) {
    var fmt = el.getAttribute('data-money-format') || '$' + '{{amount}}';
    var n = (cents || 0) / 100;
    function withDelims(v, dec, th, ds) {
      var parts = v.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(n, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        default: return withDelims(n, 2, ',', '.');
      }
    }).replace(/\.00(?=\D*$)/, '');
  }

  function img(src, w) {
    if (!src) return '';
    try { var u = new URL(src, location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; }
  }

  function sportOf(text) {
    text = (text || '').toLowerCase();
    for (var i = 0; i < SPORTS.length; i++) if (text.indexOf(SPORTS[i]) > -1) return SPORTS[i];
    return null;
  }

  /* ---------- Count-up for the amount left ---------- */
  function roll(node, key, to, formatter) {
    if (!node) return;
    var from = state.tweens[key] == null ? to : state.tweens[key];
    state.tweens[key] = to;
    if (reduceMotion || from === to) { node.textContent = formatter(to); return; }
    var start = null, dur = 450;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = Math.round(from + (to - from) * eased);
      node.textContent = formatter(val);
      if (p < 1 && state.tweens[key] === to) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---------- API ---------- */
  function api(path, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      if (body instanceof FormData) { opts.body = body; }
      else { opts.body = JSON.stringify(body); opts.headers['Content-Type'] = 'application/json'; }
    }
    return fetch(url(path), opts).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { var err = new Error(d.description || d.message || 'Error'); err.data = d; throw err; } return d; });
    });
  }
  function getCart() { return api('/cart.js').then(function (c) { state.cart = c; return c; }); }
  function broadcast() { document.dispatchEvent(new CustomEvent('ce:cart:updated', { detail: state.cart })); }

  /* ---------- Free-shipping progress ---------- */
  function tiers() {
    var list = [];
    var ship = num('data-threshold');
    var bonus = num('data-bonus');
    if (ship) list.push({ key: 'ship', at: ship, label: 'free shipping' });
    if (bonus > ship) list.push({ key: 'bonus', at: bonus, label: (cfg.bonusLabel || 'bonus reward').toLowerCase() });
    return list;
  }

  function tpl(name) { var t = $('template[data-ce-cd-' + name + ']'); return t ? t.innerHTML : ''; }

  function renderMeter(cart) {
    var box = $('[data-ce-cd-ship]');
    if (!box) return;
    var list = tiers();
    if (!list.length || !cart.item_count) { box.hidden = true; return; }
    box.hidden = false;
    var total = cart.total_price;
    var max = list[list.length - 1].at;
    var next = list.find(function (t) { return total < t.at; });
    var pct = Math.min(100, total / max * 100);

    var fill = $('[data-ce-cd-fill]');
    if (pct > 0) fill.removeAttribute('data-empty'); else fill.setAttribute('data-empty', '');
    requestAnimationFrame(function () { fill.style.width = pct + '%'; });
    box.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', Math.round(pct));

    var mark = $('[data-ce-cd-mark]');
    if (mark && list.length > 1) {
      mark.style.left = (list[0].at / max * 100) + '%';
      mark.classList.toggle('is-hit', total >= list[0].at);
    }

    var msg = $('[data-ce-cd-ship-msg]');
    var goal = $('[data-ce-cd-ship-goal]');
    if (next) {
      msg.innerHTML = 'Spend <b data-ce-cd-left></b>&nbsp;more for ' + esc(next.label);
      state.tweens.remaining = state.tweens.remaining == null ? next.at - total : state.tweens.remaining;
      var left = msg.querySelector('[data-ce-cd-left]');
      left.textContent = money(state.tweens.remaining);
      roll(left, 'remaining', next.at - total, money);
      goal.textContent = money(total) + ' / ' + money(next.at);
    } else {
      state.tweens.remaining = 0;
      msg.innerHTML = tpl('check') + '<span>' + (list.length > 1 ? 'You’ve unlocked every reward' : 'You’ve unlocked free shipping') + '</span>';
      goal.textContent = '';
    }
    box.classList.toggle('is-done', !next);
  }

  /* ---------- Items ---------- */
  function renderItems(cart) {
    var wrap = $('[data-ce-cd-items]');
    if (!cart.item_count) {
      wrap.innerHTML = $('template[data-ce-cd-empty]').innerHTML;
      state.lastKeys = {};
      return;
    }
    var prevKeys = state.lastKeys;
    var nextKeys = {};
    wrap.innerHTML = cart.items.map(function (it) {
      nextKeys[it.key] = it.quantity;
      var variant = it.product_has_only_default_variant ? '' : '<p class="ce-cd__variant">' + esc(it.variant_title) + '</p>';
      var props = '';
      if (it.properties) {
        props = Object.keys(it.properties).filter(function (k) { return k.charAt(0) !== '_' && it.properties[k]; }).map(function (k) {
          return '<p class="ce-cd__props">' + esc(k) + ': ' + esc(it.properties[k]) + '</p>';
        }).join('');
      }
      var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
      return '' +
        '<div class="ce-cd__item" data-key="' + esc(it.key) + '">' +
          '<a class="ce-cd__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="' + esc(it.product_title) + '" loading="lazy" width="76" height="76">' : '') + '</a>' +
          '<div>' +
            '<a class="ce-cd__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant + props +
            '<div class="ce-cd__qty">' +
              '<button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">' + tpl('minus') + '</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">' + tpl('plus') + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="ce-cd__right">' +
            '<p class="ce-cd__price">' + was + money(it.final_line_price) + '</p>' +
            '<button type="button" class="ce-cd__remove" data-qty="0">Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');
    state.lastKeys = nextKeys;
  }

  function renderFoot(cart) {
    $('[data-ce-cd-foot]').hidden = !cart.item_count;
    roll($('[data-ce-cd-subtotal]'), 'subtotal', cart.total_price, money);
    var disc = $('[data-ce-cd-discounts]');
    if (cart.total_discount > 0) { disc.hidden = false; disc.textContent = 'You\'re saving ' + money(cart.total_discount); }
    else disc.hidden = true;
    $('[data-ce-cd-count]').textContent = cart.item_count || '';
    var g = $('[data-ce-cd-guarantee]');
    if (g) g.hidden = !cart.item_count;
  }

  /* ---------- Upsells (bonus round) ---------- */
  function normalizeRec(p) {
    var image = p.featured_image || (p.images && p.images[0]) || (p.media && p.media[0] && p.media[0].src) || '';
    if (image && typeof image === 'object') image = image.src || '';
    return {
      id: p.id, title: p.title, handle: p.handle, url: p.url, type: p.type || p.product_type || '',
      available: p.available, price: p.price, featured_image: image,
      variants: (p.variants || []).map(function (v) { return { id: v.id, title: v.title, available: v.available, price: v.price }; })
    };
  }

  function fetchRecs(productId) {
    if (el.getAttribute('data-recs') !== 'true' || !productId) return Promise.resolve([]);
    if (state.recs[productId]) return Promise.resolve(state.recs[productId]);
    var base = el.getAttribute('data-recs-url') || '/recommendations/products';
    function get(intent) {
      return fetch(base + '.json?product_id=' + productId + '&limit=6&intent=' + intent)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d.products || []).map(normalizeRec); })
        .catch(function () { return []; });
    }
    return get('complementary').then(function (list) { return list.length ? list : get('related'); })
      .then(function (list) { state.recs[productId] = list; return list; });
  }

  function nextTier(total) { return tiers().find(function (t) { return total < t.at; }); }

  function pickUpsells(cart, recs) {
    var inCart = {};
    cart.items.forEach(function (it) { inCart[it.product_id] = true; });
    var sport = null;
    for (var i = 0; i < cart.items.length && !sport; i++) {
      var it = cart.items[i];
      sport = sportOf(it.product_title + ' ' + it.product_type + ' ' + it.handle);
    }
    var nt = nextTier(cart.total_price);
    var remaining = nt ? nt.at - cart.total_price : 0;
    var seen = {};
    var pool = (cfg.upsells || []).concat(recs || []).filter(function (p) {
      if (!p || seen[p.id] || inCart[p.id] || !p.available || !p.price) return false;
      if (!p.variants || !p.variants.some(function (v) { return v.available; })) return false;
      seen[p.id] = true;
      return true;
    });
    pool.forEach(function (p, idx) {
      var ps = sportOf(p.title + ' ' + p.type + ' ' + p.handle);
      var score = 0;
      if (sport && ps === sport) score += 3;
      else if (!ps) score += 2;
      else score -= 2;
      if (remaining > 0 && p.price >= remaining) score += 2 - Math.min(1.5, (p.price - remaining) / Math.max(remaining, 1));
      score -= idx * 0.01;
      p._score = score;
    });
    pool.sort(function (a, b) { return b._score - a._score; });
    return { list: pool.slice(0, num('data-upsell-count') || 2), sport: sport, remaining: remaining, tier: nt };
  }

  function renderUpsells(cart) {
    var box = $('[data-ce-cd-ups]');
    if (!cart.item_count) { box.hidden = true; return; }
    var firstId = cart.items[0] && cart.items[0].product_id;
    fetchRecs(firstId).then(function (recs) {
      if (state.cart !== cart) return;
      var pick = pickUpsells(cart, recs);
      if (!pick.list.length) { box.hidden = true; return; }
      var msg = (pick.sport && cfg.messages[pick.sport]) || cfg.messages['default'];
      $('[data-ce-cd-ups-title]').textContent = msg.title || '';
      var text = $('[data-ce-cd-ups-text]');
      text.textContent = pick.remaining > 0 ? (msg.text || '') : '';
      text.hidden = !text.textContent;
      $('[data-ce-cd-ups-list]').innerHTML = pick.list.map(function (p) {
        var avail = p.variants.filter(function (v) { return v.available; });
        var price = avail[0].price;
        var unlock = pick.remaining > 0 && price >= pick.remaining
          ? '<span class="ce-cd__unlock">Unlocks ' + esc(pick.tier.label) + '</span>' : '';
        var select = '';
        if (p.variants.length > 1) {
          select = '<select data-variant aria-label="Choose option for ' + esc(p.title) + '">' + avail.map(function (v) {
            return '<option value="' + v.id + '">' + esc(v.title) + '</option>';
          }).join('') + '</select>';
        }
        return '' +
          '<div class="ce-cd__up" data-pid="' + p.id + '" data-vid="' + avail[0].id + '">' +
            '<a class="ce-cd__up-img" href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image, 160)) + '" alt="" loading="lazy" width="60" height="60">' : '') + '</a>' +
            '<div>' +
              '<a class="ce-cd__up-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
              '<p class="ce-cd__up-price">' + money(price) + '</p>' + unlock + select +
            '</div>' +
            '<button type="button" class="ce-cd__add" data-upsell-add aria-label="Add ' + esc(p.title) + '">Add</button>' +
          '</div>';
      }).join('');
      box.hidden = false;
    });
  }

  function render(cart) {
    renderMeter(cart);
    renderItems(cart);
    renderFoot(cart);
    renderUpsells(cart);
    state.lastTotal = cart.total_price;
    state.lastCount = cart.item_count;
  }

  function setMsg(text) { var m = $('[data-ce-cd-msg]'); if (m) m.textContent = text || ''; }

  /* ---------- Open / close ---------- */
  var lastFocus = null;
  function open() {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ce-lock');
    var panel = $('.ce-cd__panel'); if (panel) panel.focus({ preventScroll: true });
  }
  function close() {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ce-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function refreshAndOpen() {
    var wasOpen = el.classList.contains('is-open');
    return getCart().then(function (c) {
      render(c); broadcast();
      if (!wasOpen) open();
    });
  }

  /* ---------- Actions ---------- */
  function change(key, qty, row) {
    if (row) row.classList.add('is-busy');
    setMsg('');
    return api('/cart/change.js', { id: key, quantity: qty })
      .then(function (c) { state.cart = c; render(c); broadcast(); })
      .catch(function (e) { setMsg(e.message); if (row) row.classList.remove('is-busy'); });
  }

  function addItems(payload) {
    setMsg('');
    return api('/cart/add.js', payload).then(refreshAndOpen).catch(function (e) {
      return getCart().then(function (c) { render(c); open(); setMsg(e.message); });
    });
  }

  function bind() {
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-ce-cd-close]')) { close(); return; }
      var q = e.target.closest('[data-qty]');
      if (q) {
        var row = q.closest('.ce-cd__item');
        change(row.getAttribute('data-key'), parseInt(q.getAttribute('data-qty'), 10), row);
        return;
      }
      var add = e.target.closest('[data-upsell-add]');
      if (add) {
        var card = add.closest('.ce-cd__up');
        var sel = card.querySelector('[data-variant]');
        var vid = sel ? sel.value : card.getAttribute('data-vid');
        add.disabled = true;
        addItems({ items: [{ id: Number(vid), quantity: 1 }] });
      }
    });
    el.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-variant]');
      if (!sel) return;
      var card = sel.closest('.ce-cd__up');
      var pid = Number(card.getAttribute('data-pid'));
      var all = (cfg.upsells || []).concat(Object.keys(state.recs).reduce(function (a, k) { return a.concat(state.recs[k]); }, []));
      var prod = all.find(function (p) { return p.id === pid; });
      var v = prod && prod.variants.find(function (x) { return String(x.id) === sel.value; });
      if (v) card.querySelector('.ce-cd__up-price').textContent = money(v.price);
    });
    if (window.__ceCartDocBound) return;
    window.__ceCartDocBound = true;
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-ce-cart-open]');
      if (!trigger) return;
      e.preventDefault();
      refreshAndOpen();
    });

    window.ceCartDrawer = true;
    document.addEventListener('ce:cart:add', function (e) { e.preventDefault(); refreshAndOpen(); });

    window.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      if (form.hasAttribute('data-ce-product-form')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');
      var fd = new FormData(form);
      if (e.submitter && e.submitter.name) fd.append(e.submitter.name, e.submitter.value);
      api('/cart/add.js', fd).then(refreshAndOpen).catch(function (err) {
        getCart().then(function (c) { render(c); open(); setMsg(err.message); });
      }).then(function () { if (btn) btn.removeAttribute('aria-busy'); });
    }, true);
  }

  function init() {
    el = document.querySelector('[data-ce-cart-drawer]');
    if (!el || el.__ce) return;
    el.__ce = true;
    try { cfg = JSON.parse(el.querySelector('[data-ce-cd-config]').textContent); } catch (e) { cfg = { messages: { 'default': {} }, upsells: [] }; }
    cfg.upsells = (cfg.upsells || []).map(normalizeRec);
    bind();
    // Prime totals so the first add after page load can trigger the unlock celebration.
    getCart().then(function (c) {
      state.lastTotal = c.total_price; state.lastCount = c.item_count;
      c.items.forEach(function (it) { state.lastKeys[it.key] = it.quantity; });
      state.tweens.subtotal = c.total_price;
    }).catch(function () {});
    document.addEventListener('shopify:section:select', function (e) { if (e.target.querySelector && e.target.querySelector('[data-ce-cart-drawer]')) refreshAndOpen(); });
    document.addEventListener('shopify:section:deselect', function (e) { if (e.target.querySelector && e.target.querySelector('[data-ce-cart-drawer]')) close(); });
    if (/[?&]ce_cart=open/.test(location.search)) refreshAndOpen();
  }

  window.ceCart = {
    open: refreshAndOpen, close: close,
    refresh: function () { return getCart().then(function (c) { render(c); broadcast(); }); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.querySelector && e.target.querySelector('[data-ce-cart-drawer]')) { el = null; init(); }
  });
})();
